import type { ReactChild } from 'react';
import React from 'react';

import { withToolbarContext } from './../../../../ricos-context';

import type { ToolbarItemProps } from '../../../types';
import { PlainToolbarButton } from '../ToolbarButton';

const CustomButton = ({
  toolbarItem,
  context,
  dataHook,
  children,
}: ToolbarItemProps & { children: ReactChild }) => {
  const { isMobile } = context || {};

  return (
    <PlainToolbarButton
      isMobile={isMobile}
      active={toolbarItem.attributes.active}
      disabled={toolbarItem.attributes.disabled}
      onClick={e => toolbarItem.commands?.click?.(e)}
      dataHook={dataHook}
      tooltip={toolbarItem.presentation?.tooltip}
    >
      {children}
    </PlainToolbarButton>
  );
};

export default withToolbarContext(CustomButton);
